export function makeIsNormalFloat<T>(errorMsg: T) {
  return (value?: string | number) => {
    if (!value && value !== 0) {
      return undefined;
    }
    const valueEdited = value.toString().replace(',', '.') || '0';
    const number = Number(Number(valueEdited).toFixed(1));

    if (number !== Infinity && String(number) === valueEdited && number >= 0) {
      return undefined;
    }

    return errorMsg;
  };
}
